<!-- @format -->
<div
	class="nav-link hmf-pb-0 hmf-mb-l"
	*ngIf="data">
	<ul
		class="hmf-flex-wrap hmf-nav-ul hmf-nav-ul-{{
			numColumns
		}} hmf-display-flex hmf-justify-content-around"
		*ngFor="let data of chunkedData; let i = index">
		<li *ngFor="let nav of chunkedData[i]">
			<ng-container *ngIf="showButton() && nav !== null">
				<button
					hmf-action-text
					classList="hmf-px-m hmf-pt-s hmf-pb-m"
					[attr.dataEm]="createPageNavDataTag(nav.title)"
					[attr.altText]="nav.title"
					[attr.target]="targetService(nav.link)"
					[attr.aria-label]="nav.title"
					(click)="scrollToElement(nav.link)">
					{{ nav.title }}
				</button>
			</ng-container>
			<ng-container *ngIf="!showButton() && nav !== null">
				<a
					href="javascript:void(0);"
					[attr.data-em]="createPageNavDataTag(nav.title)"
					class="gg-nav"
					altText="nav.title"
					(click)="scrollToElement(nav.link)">
					{{ nav.title }}
				</a>
			</ng-container>
		</li>
	</ul>
</div>
